import { Button, H3, P, UniversalLink } from "@template/components";
import * as S from "./styles.ts";
import ChevronRight from "@template/icons/ChevronRight.tsx";

export type NumberPickerFooterLink = {
  title: string;
  href: string;
};

export const NumberPickerFooter = ({
                                     title,
                                     links,
                                   }: {
  title: React.ReactNode;
  links: NumberPickerFooterLink[];
}) => {
  return (
    <S.NumberPickerFooterWrapper>
      <S.NumberPickerFooterContainer>
        <S.NumberPickerFooterTitle>{title}</S.NumberPickerFooterTitle>
        <S.NumberPickerFooterLinks>
          <S.TextSection>
            <H3>Want to buy another phone number?</H3>
            <P>Choose from our most popular area codes.</P>
          </S.TextSection>
          <S.LinksSection>
            {links.map((link, index) => (
              <Button
                size="md"
                navigation={{
                  href: link.href,
                }}
                title={`Purchase ${title} phone numbers`}
                key={index}
              >
                {link.title}
              </Button>
            ))}
          </S.LinksSection>
          <UniversalLink
            href="#number-search"
            title="Anchor link to phone numbers search bar"
          >
            <S.FooterLink>
              <P>Start a new search</P>

              <ChevronRight />
            </S.FooterLink>
          </UniversalLink>
        </S.NumberPickerFooterLinks>
      </S.NumberPickerFooterContainer>
    </S.NumberPickerFooterWrapper>
  );
};
